import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { Tabs ,Modal,message,Input,Select} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

import 'remixicon/fonts/remixicon.css'
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ModalImage from "react-modal-image";
import CircularProgress from '@material-ui/core/CircularProgress';

import {HeartOutlined} from '@ant-design/icons';





import InfiniteScroll from "react-infinite-scroll-component";
import ReadMoreAndLess from 'react-read-more-less';
import PerfectScrollbar from "react-perfect-scrollbar";
import 'react-html5video/dist/styles.css';



const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			post_visible: false,
			auth_token:'',
			comment_text:'',
			type:'',
			division:'',
			class_count:0,
			student_count:0,
			active_student_count:0,
			inactive_student_count:0,
			school_count:0,
			show_uploading: 'false',
			new_post: 'false',
			value:0,
			scrolldiv:0,
			notice_title : '',
			program_id : '',
			school_email : '',
			current_profile_image : '',
			post_list : [],
			like_list : [],
			single_post : [],
			manage_class : [],
			division_list : [],
			page : 1,
			count : 0,
			empty : 1,
			placement: 'top',
			items: Array.from({ length: 10 })
		}
		this.logout = this.logout.bind(this);
		this.sharePost = this.sharePost.bind(this);
		this.onChange = this.onChange.bind(this);
		this.change_program = this.change_program.bind(this);
		this.change_division = this.change_division.bind(this);
	}
	
	sharePost = (id) => {
		var url='https://app.kidzonia.co.in/single_post/'+id;
		var text='I came across using kidzonia';
		window.sharePost(url,text);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}
		if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var type = storedArray['data'][0]['type'];
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			this.setState({ type: type,school_id:school_id,user_id:user_id });
			window.showAndroidToast(user_id);
		    window.getIOSToken(user_id);
	    }
		setTimeout(() => {
			this.checkData();
		}, 200);
		
		
		
		//setInterval(this.checkNewpost, 100000);
	}
	
	scrollTop = () =>{
	   if(this.props.location.state){
			var post_id = this.props.location.state[0].post_id;
			if(post_id!=''){
			 if(document.getElementById(post_id)){
				document.getElementById(post_id).scrollIntoView();
			 }
			}
		}
	};
	
	fetchMoreData = () => {
			setTimeout(() => {
				if (localStorage.getItem('schoolData')) {
					var storedArray = JSON.parse(localStorage.getItem("schoolData"));
					var school_id = storedArray['data'][0]['school_id'];
					var user_id = storedArray['data'][0]['user_id'];
					var type = storedArray['data'][0]['type'];
					var program_id = this.state.program_id;
					var division = this.state.division;
					var page = parseInt(this.state.page)+1;
					var app = {user_id : user_id,school_id:school_id,program_id:program_id,page:page,type:type,division:division}
					      
					getData('parents/gallery_view', app).then((result) => {
						let responseJson = result;
						if (responseJson.data) {					
							var joined = this.state.post_list.concat(result['data']);
							this.setState({ post_list: joined })
							this.setState({
								page: page,
								items: this.state.items.concat(Array.from({ length: 10 }))
							})
							if(result['count'] > 0){
								localStorage.setItem('new_post_id', result['data'][0]['id']);
							}else{
								this.setState({
									empty: 0,
								});
							}	
						}
					});
				}
			}, 900);
	}
	
	checkNewpost = () => {
			if (localStorage.getItem('new_post') == 'true') {
				this.setState({
					show_uploading: 'true'
				});
				this.checkPost();
			} else {
				this.setState({
					show_uploading: 'false',
					file_list: []
				});
			}
			if (localStorage.getItem('schoolData')) {
				var storedArray = JSON.parse(localStorage.getItem("schoolData"));
				var user_id = storedArray['data']['user_id'];
				if (localStorage.getItem('new_post_id') > localStorage.getItem('last_post_id')) {
					localStorage.setItem('new_post', 'false');
					this.setState({
						show_uploading: 'false',
						file_list: []
					});
					localStorage.setItem('last_post_id', localStorage.getItem("new_post_id"));
					message.config({
						top: 150
					});
					message.success('New post added', 2);
				}
			}
		}
		
	showModal = (id) => {
		this.setState({
		  visible: true,
		});
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var app = {
		  post_id    : id,
		  user_id     : user_id
		}
		getData('parents/post_like_list',app).then((result) => {
			let responseJson = result;
			  if(responseJson){
				  if(result['status']==200){
					  this.setState({
						like_list: result['data']
					  });
					}
			  }
		});
	  };
		
	showLikeModal = (id) => {
		this.setState({
		  visible: true,
		});
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var app = {
		  comment_id    : id,
		  user_id     : user_id
		}
		getData('parents/comment_like_list',app).then((result) => {
			let responseJson = result;
			  if(responseJson){
				  if(result['status']==200){
					  this.setState({
						like_list: result['data']
					  });
					}
			  }
		});
	  };
	  
	showPostModal = (id) => {
		this.setState({
		  post_visible: true,
		});
		setTimeout(() => {
			this.SinglePost(id);
		}, 500);
	}; 

	SinglePost = (id) => {
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var app = {
		  post_id    : id,
		  user_id     : user_id,
		  program_id     : this.state.program_id,
		  school_id     : this.state.school_id,
		}
		getData('parents/single_post',app).then((result) => {
			let responseJson = result;
			  if(responseJson){
				  if(result['status']==200){
					  this.setState({
						single_post: result['data'],
						current_profile_image:result['data'][0]['current_profile_image']
					  });
					}
			  }
		});
	};  
	
	handlePostCancel = () => {
		this.setState({ post_visible: false,single_post:[] });
	};

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false,like_list:[] });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false,like_list:[] });
	  };
	  
	  applyComment=(id)=>{
			this.props.history.push({
				pathname: '/post_comment/'+id,
				state: [{page_name:'class-story',post_id:id}],
			})
	  }
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var page = this.state.page;
			var program_id = this.state.program_id;
			var app = {user_id : user_id,school_id:school_id,type:type}
			getData('auth/get_token',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							auth_token: result['token']
						});
					}else{
						this.setState({
							auth_token: ''
						});
					}
				}
			});
			getData('auth/dashboard_data',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							class_count: result['data'][0]['class_count'],
							student_count: result['data'][0]['student_count'],
							active_student_count: result['data'][0]['active_student_count'],
							inactive_student_count: result['data'][0]['inactive_student_count'],
							school_count: result['data'][0]['school_count'],
							admission_count: result['data'][0]['admission_count'],
						});
					}else{
						this.setState({
							dashboard_data: ''
						});
					}
				}
			});
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						setTimeout(() => {
						  this.setState({
								manage_class: result['data'],
							});
							if(this.state.type == 'staff'){
								this.setState({
									program_id: result['data'][0]['id'],
								});
								this.change_program(result['data'][0]['id']);
							}else{
								 this.checkPost();
							}
							
						}, 100);
						
					}else{
						this.setState({
							manage_class: [],
							
						});
					}
				}
			});	
	  }
	}
	
	checkPost(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var page = this.state.page;
			var program_id = this.state.program_id;
			var division = this.state.division;
			var app_ = {school_id:school_id,program_id:program_id,page:page,user_id:user_id,division:division,type:type}
			getData('parents/gallery_view',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					
					if(result['status'] == 200){
						this.setState({
							post_list: result['data'],
							count: result['count'],
							
						});
						if(result['count'] > 0){
							localStorage.setItem('new_post_id', result['data'][0]['id']);
							localStorage.setItem('last_post_id', result['data'][0]['id']);
						}else{
							this.setState({
								empty: 0,
							});
						}	
					}else{
						this.setState({
							post_list: [],
							count: 0,
							empty: 0,
							
						});
					}
				}
			});
	  }
	}

	  
	 addLike=(id,e)=>{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
	   var user_id = storedArray['data'][0]['user_id'];
		var app = {
		  post_id    : id,
		  user_id     : user_id
		}
	  getData('parents/post_like',app).then((result) => {
		let responseJson = result;
		  if(responseJson){
			  if(result['status']==200){
			   this.checkPost();
			}
		  }
		});
	} 

	handleSubmit=(id,e)=>{
		if(this.state.comment_text != ''){
			e.preventDefault();
			this.setState({ loading: true });
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var post_id = id;
			var app = {
			   comment : this.state.comment_text,
			   user_id : user_id,
			   post_id : post_id
			}
			getData('parents/post_comment',app).then((result) => {
			if(result.status==400){
				alert(result.message);
			}
			if(result.status==200){
				message.config({ top: 150});
				message.success('Comment added',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				setTimeout(() => {
					this.SinglePost(id);
				}, 500);
			}
			});
		}else{
			message.config({ top: 150});
			message.error('Please Insert Comment',2);
		}	
	}

	onChange(e){
      this.setState({[e.target.name]:e.target.value});
    }

	addCommentLike=(post_id,id,e)=>{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var app = {
		  comment_id : id,
		  user_id : user_id
		}
	  getData('parents/comment_like',app).then((result) => {
		let responseJson = result;
		  if(responseJson){
			  if(result['status']==200){
			   setTimeout(() => {
					this.SinglePost(post_id);
				}, 500);
			}
		  }
		});
	  }
	  
	change_program(event){
        this.setState({program_id: event,division_list:[],division:'',page:1});
		var app = {user_id : this.state.user_id,program_id:event,school_id:this.state.school_id}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					setTimeout(() => {
					  this.setState({
							division_list: result['data'],
							division: result['data'][0]['id'],
						});
					}, 100);
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});	
		setTimeout(() => {
					 this.checkPost();
		}, 500);
    }  
	
	change_division(event){
         this.setState({division: event,page:1});
		 setTimeout(() => {
					 this.checkPost();
		}, 500);
     }
	  
	logout(){
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login/';
	}
	
	
	

	renderTextWithLinks = (text) => {
		// Regular expression to find URLs in the text
		const urlRegex = /(https?:\/\/[^\s]+)/g;
		const parts = text.split(urlRegex);

		return parts.map((part, index) => {
		  if (part.match(urlRegex)) {
			return (
				<><br/>
			  <a key={index} href={part} target="_blank" className="story-url">
				{part}
			  </a><br/><br/>
			  </>
			);
		  } else {
			return part;
		  }
		});
	  };

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<>
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Dashboard
								
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> Dashboard </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div class="row dashboard">
				
				<div class="col-md-6 ">
				<div class="col-md-12 no-padd mb-20 form-group">
					<div class="row">
					<div class="col-md-3">
						<label className="dashborad-class-lbl">Filter Class:</label>
					</div>
					<div class="col-md-5">
					<Select className="dashborad-class-ddl" onChange={this.change_program} value={this.state.program_id} >
						{this.state.type !='staff' && (<Select.Option value=''>All </Select.Option>)}
							{this.state.manage_class.map((list) => (
									<Select.Option value={list.id}>{list.name}</Select.Option>
							))}
					</Select>
					</div>
					<div class="col-md-4">
					<Select onChange={this.change_division} value={this.state.division}>
							{this.state.division_list.map((list) => (
								<Select.Option value={list.id}>{list.name}</Select.Option>
							))}
					</Select>
					</div>
					</div>
				</div>
					<InfiniteScroll
	  dataLength={this.state.items.length}
	  next={this.fetchMoreData}
	  hasMore={true}
	  className=""
	  loader={<div class="loader-wrapperss ">
                <div id="shadow-dom" class="view-wrap">
                    <div class="columns">
					
					<div class="column is-6">
                            <div class="placeload post-placeload">
                                <div class="header">
                                    <div class="img loads"></div>
                                    <div class="header-content">
                                        <div class="content-shape loads"></div>
                                        <div class="content-shape loads"></div>
                                    </div>
                                </div>
                                <div class="image-placeholder loads"></div>
                                <div class="placeholder-footer">
                                    <div class="footer-block">
                                        <div class="img loads"></div>
                                        <div class="inner-wrap">
                                            <div class="content-shape loads"></div>
                                            <div class="content-shape loads"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					
					</div>
				</div>
    </div>}
	>
				  
				  {this.state.post_list.map((list)=>(
					<>
					<div class="profile-post bg-white" id={list.id}>
					   <div class="card is-post">
						  <div class="content-wrap">
							 <div class="card-heading">
								<div class="user-block">
								   <div class="image">
									  <img src="https://erp.kidzonia.co.in/panel/uploads/user_image/placeholder.png" class="child-avt"/> 
								   </div>
								   <div class="user-info">
									  {list.staff_name}
									  <span class="time album-name">{list.album_name}</span>
								   </div>
								</div>
							 </div>
							 <div class="card-body post-body">
								
								
								{(() => {
								var first = list.media_list;
								if (list.media_count>4) {
								return (
								<div class="masonry-grid"  uk-lightbox="animation: slide">
								   <div class="masonry-column-left">
									  {(() => {  
									  if (first[0].type=='image') {
									  return (	
									  <img src={first[0].url} className="height100"  onClick={this.showPostModal.bind(this,list.id)} />
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[1].type=='image') {
									  return (	
									  <img src={first[1].url} className="height100"  onClick={this.showPostModal.bind(this,list.id)} />
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[0].type=='video') {
									  return (	
									  <a data-type="video" href={first[0].url}>
										 <div class="rh5v-DefaultPlayer_component ">
											<img src={first[0].thumb} alt="" class="height100"/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[1].type=='video') {
									  return (	
									  <a data-type="video" href={first[1].url}>
										 <div class="rh5v-DefaultPlayer_component ">
											<img src={first[1].thumb} alt="" class="height100"/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
									  )
									  }
									  })()}
								   </div>
								   <div class="masonry-column-right">
									  {(() => {  
									  if (first[2].type=='image') {
									  return (	
									 
									  <img src={first[2].url} className="height100"  onClick={this.showPostModal.bind(this,list.id)} />
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[3].type=='image') {
									  return (	
									
									  <img src={first[3].url} className="height100"  onClick={this.showPostModal.bind(this,list.id)} />
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[4].type=='image') {
									  return (	
									 
									   <img src={first[4].url} className="height100"  onClick={this.showPostModal.bind(this,list.id)} />
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[2].type=='video') {
									  return (	
									  <a data-type="video" href={first[2].url}>
										 <div class="rh5v-DefaultPlayer_component ">
											<img src={first[2].thumb} alt="" class="height100"/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[3].type=='video') {
									  return (	
									  <a data-type="video" href={first[3].url}>
										 <div class="rh5v-DefaultPlayer_component ">
											<img src={first[3].thumb} alt="" class="height100"/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
									  )
									  }
									  })()} 
									  {(() => {  
									  if (first[4].type=='video') {
									  return (	
									  <a data-type="video" href={first[4].url}>
										 <div class="rh5v-DefaultPlayer_component ">
											<img src={first[4].thumb} alt="" class="height100"/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
									  )
									  }
									  })()} 
								   </div>
								</div>
								)
								}
								if (list.media_count =='4') {
								return (
								<div class="triple-grid"  uk-lightbox="animation: slide">
								   {(() => {  
								   if (first[0].type=='image') {
								   return (	
								   <div class="is-half">
									    <img src={first[0].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[1].type=='image') {
								   return (	
								   <div class="is-half">
									   <img src={first[1].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[2].type=='image') {
								   return (	
								   <div class="is-half">
										 <img src={first[2].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[3].type=='image') {
								   return (	
								   <div class="is-half">
									  <img src={first[3].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[0].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[0].url}>
										 <div class="rh5v-DefaultPlayer_component vid_screen">
											<img src={first[0].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()}
								   {(() => {  
								   if (first[1].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[1].url}>
										 <div class="rh5v-DefaultPlayer_component vid_screen">
											<img src={first[1].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[2].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[2].url}>
										 <div class="rh5v-DefaultPlayer_component vid_screen">
											<img src={first[2].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[3].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[3].url}>
										 <div class="rh5v-DefaultPlayer_component vid_screen">
											<img src={first[0].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								</div>
								)
								}
								if (list.media_count =='3') {
								return (
								<div class="triple-grid"  uk-lightbox="animation: slide">
								   {(() => {  
								   if (first[0].type=='image') {
								   return (	
								  <div class="w-100">
								    <img src={first[0].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[1].type=='image') {
								   return (	
								   <div class="is-half">
								       <img src={first[1].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[2].type=='image') {
								   return (	
								   <div class="is-half">
									   <img src={first[2].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[0].type=='video') {
								   return (	
								   <a data-type="video" href={first[0].url}>
									  <div class="rh5v-DefaultPlayer_component">
										 <img src={first[0].thumb} alt=""/>
										 <div class="rh5v-Overlay_component ">
											<span class="rh5v-Overlay_inner">
											   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
												  <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
											   </svg>
											</span>
										 </div>
									  </div>
								   </a>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[1].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[1].url}>
										 <div class="rh5v-DefaultPlayer_component">
											<img src={first[1].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[2].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[2].url}>
										 <div class="rh5v-DefaultPlayer_component">
											<img src={first[2].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								</div>
								)
								}
								if (list.media_count =='2') {
								return (
								<div class="triple-grid 2"  uk-lightbox="animation: slide">
								   {(() => {  
								   if (first[0].type=='image') {
								   return (	
								   <div class="is-half">
									   <img src={first[0].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[1].type=='image') {
								   return (	
								   <div class="is-half">
									   <img src={first[1].url} onClick={this.showPostModal.bind(this,list.id)} />
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[0].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[0].url}>
										 <div class="rh5v-DefaultPlayer_component">
											<img src={first[0].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								   {(() => {  
								   if (first[1].type=='video') {
								   return (	
								   <div class="is-half">
									  <a data-type="video" href={first[1].url}>
										 <div class="rh5v-DefaultPlayer_component">
											<img src={first[1].thumb} alt=""/>
											<div class="rh5v-Overlay_component ">
											   <span class="rh5v-Overlay_inner">
												  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
													 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
												  </svg>
											   </span>
											</div>
										 </div>
									  </a>
								   </div>
								   )
								   }
								   })()} 
								</div>
								)
								}
								if (list.media_count =='1') {
								return (
								<div class="masonry-grid img1" uk-lightbox="animation: slide">
								   {(() => { 
								   if (first[0].type=='image') {
								   return (
								   <img src={first[0].url} onClick={this.showPostModal.bind(this,list.id)} />
								)
								}
								})()} 
								{(() => {  
								if (first[0].type=='video') {
								return (	
								<div class="full">
								   <video width="100%" height="240" controls>
									  <source src={first[0].url} type="video/mp4" />
									  <source src={first[0].url} type="video/ogg" />
									</video>
								</div>
								)
								}
								})()} 
							 </div>
							 )
							 }
							 if (list.media_count =='0') {
								return (
									<>
									{(() => {
									if (list.text!='') {
									return (
										<div class="card-footer pb-0 pl-0 render-css">
										{this.renderTextWithLinks(list.text)}
											  
										</div>
									)
									}
									})()}
									</>
							 )
							 }
							 })()}
							 
							 
							
							 <div class="post-image">
								
								<div class="fab-wrapper">
									<span onClick={this.sharePost.bind(this,list.id)}>
										<img class="share-img" src={`${process.env.PUBLIC_URL}/assets/icons/send.png`} alt="" />
									</span>
								</div>
								<div class="fab-wrapper post_com" onClick={this.showPostModal.bind(this,list.id)}>
									<i class="ri-chat-3-line"></i>
								</div>
								<div class="like-wrapper">
								   <a id={`post_like_${list.id}`} className={`like-button ${list.is_like=='1'?'':''}`} onClick={this.addLike.bind(this,list.id)}>
								   {list.is_like=='1'?(<>
										<i class="ri-heart-3-fill"></i>
								   
								   </>):(<>
										<i class="ri-heart-3-line"></i>
								   </>)}
								   
								   </a>
								</div>
							 </div>
						  </div>
						  <div class="card-footer pb-0 pt-0">
							 <div class="social-count">
								<a className={`setting-text ${list.like_count>
								'0'?'':'hide_count'}`} id={`post_like_div_${list.id}`} onClick={this.showModal.bind(this,list.id)}>
								<div class="likes-count">
								   <img src={`${process.env.PUBLIC_URL}/assets/icons/like_dark.png`} alt="" />
								   <span id={`post_like_count_${list.id}`}>{list.like_count}</span>
								</div>
								</a>
								{(() => {   if (list.comment_count > '0') {
								return (	
								<a onClick={this.showPostModal.bind(this,list.id)} class="setting-text">
								<div class="comments-count">
								   <img src={`${process.env.PUBLIC_URL}/assets/icons/post_message_dark.png`} alt="" />
								   <span>{list.comment_count}</span>
								</div>
								</a>
								)
								}
								})()} 
								
							 </div>
						  </div>
							{(() => {
								if (list.text!='' && list.media_count > '0') {
								return (
								<div class="card-footer pb-0  pt-0 pl-25">
								   <ReadMoreAndLess
									  ref={list.text}
									  className="read-more-content"
									  charLimit={100}
									  readMoreText="Read more"
									  readLessText="Read less"
									  >
									  {list.text}
								   </ReadMoreAndLess>
								</div>
								)
								}
								})()}
							<div class="card-footer pt-0 pl-25">	
								<span class="time">{list.date}</span>	
							</div>
						
						
							
					   </div>
					</div>
					</div>
				  </>
				  ))}
				  
				  {this.state.count == 0 & this.state.empty == 0 ? (<>
						<div class="no-post-found"><i class="ri-layout-fill"></i> No Post Found !!!</div>
				  </>):(<></>)}	
				  
                   </InfiniteScroll> 
					
					
					<Modal
					  title="Likes"
					  visible={this.state.visible}
					  onCancel={this.handleCancel}
					  closable={true}
					  className="history single-activity like-drawer"
					>
					{this.state.like_list.map((list) => (
						<div class="like_user">
							<div class="image"><img src={list.image} /></div>
							<div class="name">{list.name}</div>
						</div>
					))}
					  
					</Modal>
					
					
					<Modal
					  visible={this.state.post_visible}
					  onCancel={this.handlePostCancel}
					  closable={true}
					  className="history single-activity sinlge-post-modal"
					>
					<>
					<div class="row">
						<div class="col-md-6 image">
							{this.state.single_post.map((list)=>(
							<>
							<div class="profile-post bg-white" id={list.id}>
							   <div class="card is-post">
								  <div class="content-wrap">
									 <div class="card-body post-body">
										{(() => {
										var first = list.media_list;
										if (list.media_count>4) {
										return (
										<div class="masonry-grid"  uk-lightbox="animation: slide">
										   <div class="masonry-column-left">
											  {(() => {  
											  if (first[0].type=='image') {
											  return (	
											  
											  <ModalImage  small={first[0].url} large={first[0].url}  className="height100" hideDownload="true"/>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[1].type=='image') {
											  return (	
											  
											  <ModalImage  small={first[1].url} large={first[1].url}  className="height100" hideDownload="true"/>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[0].type=='video') {
											  return (	
											  <a data-type="video" href={first[0].url}>
												 <div class="rh5v-DefaultPlayer_component ">
													<img src={first[0].thumb} alt="" class="height100"/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[1].type=='video') {
											  return (	
											  <a data-type="video" href={first[1].url}>
												 <div class="rh5v-DefaultPlayer_component ">
													<img src={first[1].thumb} alt="" class="height100"/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
											  )
											  }
											  })()}
										   </div>
										   <div class="masonry-column-right">
											  {(() => {  
											  if (first[2].type=='image') {
											  return (	
											  <ModalImage  small={first[2].url} large={first[2].url}  className="height100" hideDownload="true"/>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[3].type=='image') {
											  return (	
											  <ModalImage  small={first[3].url} large={first[3].url}  className="height100" hideDownload="true"/>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[4].type=='image') {
											  return (	
											 
											  <ModalImage  small={first[4].url} large={first[4].url}  className="height100" hideDownload="true"/>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[2].type=='video') {
											  return (	
											  <a data-type="video" href={first[2].url}>
												 <div class="rh5v-DefaultPlayer_component ">
													<img src={first[2].thumb} alt="" class="height100"/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[3].type=='video') {
											  return (	
											  <a data-type="video" href={first[3].url}>
												 <div class="rh5v-DefaultPlayer_component ">
													<img src={first[3].thumb} alt="" class="height100"/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
											  )
											  }
											  })()} 
											  {(() => {  
											  if (first[4].type=='video') {
											  return (	
											  <a data-type="video" href={first[4].url}>
												 <div class="rh5v-DefaultPlayer_component ">
													<img src={first[4].thumb} alt="" class="height100"/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
											  )
											  }
											  })()} 
										   </div>
										</div>
										)
										}
										if (list.media_count =='4') {
										return (
										<div class="triple-grid fourth"  uk-lightbox="animation: slide">
										   {(() => {  
										   if (first[0].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[0].url} large={first[0].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[1].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[1].url} large={first[1].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[2].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[2].url} large={first[2].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[3].type=='image') {
										   return (	
										   <div class="is-half">
											 <ModalImage  small={first[3].url} large={first[3].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[0].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[0].url}>
												 <div class="rh5v-DefaultPlayer_component vid_screen">
													<img src={first[0].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()}
										   {(() => {  
										   if (first[1].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[1].url}>
												 <div class="rh5v-DefaultPlayer_component vid_screen">
													<img src={first[1].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[2].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[2].url}>
												 <div class="rh5v-DefaultPlayer_component vid_screen">
													<img src={first[2].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[3].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[3].url}>
												 <div class="rh5v-DefaultPlayer_component vid_screen">
													<img src={first[0].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										</div>
										)
										}
										if (list.media_count =='3') {
										return (
										<div class="triple-grid"  uk-lightbox="animation: slide">
										   {(() => {  
										   if (first[0].type=='image') {
										   return (	
										  <div class="w-100">
										   <ModalImage  small={first[0].url} large={first[0].url} className="third" hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[1].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[1].url} large={first[1].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[2].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[2].url} large={first[2].url} hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[0].type=='video') {
										   return (	
										   <a data-type="video" href={first[0].url}>
											  <div class="rh5v-DefaultPlayer_component">
												 <img src={first[0].thumb} alt=""/>
												 <div class="rh5v-Overlay_component ">
													<span class="rh5v-Overlay_inner">
													   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
														  <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
													   </svg>
													</span>
												 </div>
											  </div>
										   </a>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[1].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[1].url}>
												 <div class="rh5v-DefaultPlayer_component">
													<img src={first[1].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[2].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[2].url}>
												 <div class="rh5v-DefaultPlayer_component">
													<img src={first[2].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										</div>
										)
										}
										if (list.media_count =='2') {
										return (
										<div class="triple-grid 2 second"  uk-lightbox="animation: slide">
										   {(() => {  
										   if (first[0].type=='image') {
										   return (	
										   <div class="is-half">
											 <ModalImage  small={first[0].url} large={first[0].url} showRotate="true" hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[1].type=='image') {
										   return (	
										   <div class="is-half">
											  <ModalImage  small={first[1].url} large={first[1].url} showRotate="true" hideDownload="true" />
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[0].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[0].url}>
												 <div class="rh5v-DefaultPlayer_component">
													<img src={first[0].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										   {(() => {  
										   if (first[1].type=='video') {
										   return (	
										   <div class="is-half">
											  <a data-type="video" href={first[1].url}>
												 <div class="rh5v-DefaultPlayer_component">
													<img src={first[1].thumb} alt=""/>
													<div class="rh5v-Overlay_component ">
													   <span class="rh5v-Overlay_inner">
														  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" class="rh5v-Overlay_icon" fill="#fff">
															 <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"></path>
														  </svg>
													   </span>
													</div>
												 </div>
											  </a>
										   </div>
										   )
										   }
										   })()} 
										</div>
										)
										}
										if (list.media_count =='1') {
										return (
										<div class="masonry-grid img1" uk-lightbox="animation: slide">
										   {(() => { 
										   if (first[0].type=='image') {
										   return (
										   <ModalImage  small={first[0].url} large={first[0].url} hideDownload="true" />
										)
										}
										})()} 
										{(() => {  
										if (first[0].type=='video') {
										return (	
										<div class="full">
										   <video width="100%" height="240" controls>
											  <source src={first[0].url} type="video/mp4" />
											  <source src={first[0].url} type="video/ogg" />
											</video>
										</div>
										)
										}
										})()} 
									 </div>
									 )
									 }
									 if (list.media_count =='0') {
										return (
											<>
											{(() => {
											if (list.text!='') {
											return (
												<div class="card-footer pb-0 pl-0">
													  {list.text}
												</div>
											)
											}
											})()}
											</>
									 )
									 }
									 })()}
								  </div>
							   </div>
							</div>
							</div>
						  </>
						  ))}
						</div>
						<div class="col-md-6 text">
							{this.state.single_post.map((list)=>(
							<>
							<div class="profile-post bg-white" id={list.id}>
							   <div class="card is-post">
								  <div class="content-wrap">
									 <div class="card-heading">
										<div class="user-block">
										   <div class="image">
											  <img src="https://erp.kidzonia.co.in/panel/uploads/user_image/placeholder.png" class="child-avt"/> 
										   </div>
										   <div class="user-info">
											  {list.staff_name}
											  <span class="time album-name">{list.album_name}</span>
										   </div>
										</div>
									 </div>
									 <div class="card-body post-body">
									 <div class="post-image">
										
										<div class="fab-wrapper">
											<span onClick={this.sharePost.bind(this,list.id)}>
												<img class="share-img" src={`${process.env.PUBLIC_URL}/assets/icons/send.png`} alt="" />
											</span>
										</div>
										<div class="fab-wrapper post_com">
											<i class="ri-chat-3-line"></i>
										</div>
										<div class="like-wrapper">
										   <a id={`post_like_${list.id}`} className={`like-button ${list.is_like=='1'?'':''}`} onClick={this.addLike.bind(this,list.id)}>
										   {list.is_like=='1'?(<>
												<i class="ri-heart-3-fill"></i>
										   
										   </>):(<>
												<i class="ri-heart-3-line"></i>
										   </>)}
										   
										   </a>
										</div>
									 </div>
								  </div>
								  <div class="card-footer pb-0 pt-0 ">
									 <div class="social-count">
										<a className={`setting-text ${list.like_count>
										'0'?'':'hide_count'}`} id={`post_like_div_${list.id}`} onClick={this.showModal.bind(this,list.id)}>
										<div class="likes-count">
										   <img src={`${process.env.PUBLIC_URL}/assets/icons/like_dark.png`} alt="" />
										   <span id={`post_like_count_${list.id}`}>{list.like_count}</span>
										</div>
										</a>
										{(() => {   if (list.comment_count > '0') {
										return (	
										<a onClick={this.showPostModal.bind(this,list.id)} class="setting-text">
										<div class="comments-count">
										   <img src={`${process.env.PUBLIC_URL}/assets/icons/post_message_dark.png`} alt="" />
										   <span>{list.comment_count}</span>
										</div>
										</a>
										)
										}
										})()} 
										
									 </div>
								  </div>
								  <div class="comment_list bt">
									{(() => {
									if (list.text!='' && list.media_count > '0') {
									return (
									<div class="card-footer pb-0  pt-0 pl-25">
										  {list.text}
									</div>
									)
									}
									})()}
									<div class="card-footer pt-0 pl-25">	
									<span class="time">{list.date}</span>	
									</div>
								
									{list.comment_list.map((comment) => (
                           <div class="card-body comm-padd card is-post mb-10">
                              <div class="user-block">
                                 <div class="image">
                                   <img src={comment.profile_image} data-demo-src={comment.profile_image} data-user-popover="1" alt="" />
                                 </div>
                                 <div class="user-info">
                                    <span class="user-name">{comment.username} </span>
                                    <span class="comment">{comment.comment}</span>
                                 </div>
                              </div>
                              <div className="user-comment">
                                 <span class="time">{comment.added_date}</span>
                                 <div class="card-footer">
                                    <div class="social-count">
									{(() => {   if (comment.like_count > '0') {
										return (
										<a onClick={this.showLikeModal.bind(this,comment.comment_id)} class="setting-text">
                                       <div class="likes-count" >
                                          <img src={`${process.env.PUBLIC_URL}/assets/icons/like_dark.png`} alt="" />
                                          <span>{comment.like_count}</span>
                                       </div>
									   </a>
									   )
								   }
								   })()} 
									   
                                    </div>
                                 </div>
                                 <div class="post-image">
                                    <div class="like-wrapper">
                                       <a className={`like-button ${comment.is_like=='1'?'':''}`} onClick={this.addCommentLike.bind(this,list.id,comment.comment_id)}>
										  {comment.is_like=='1'?(<>
											<i class="ri-heart-fill"></i>
									   
										   </>):(<>
												<i class="ri-heart-line"></i>
										   </>)}
                                       </a>
                                    </div>
                                 </div>
                              </div>
                           </div>
                          ))}

						</div>

									<div className="example-screen footer_botoom" style={{'display':'block','position':'fixed','bottom':'30px','width':'43%','z-index':'9','background':'white'}}>
										<div class="user-comment border-top mt-0">
											<div class="com-img">
												<img src={this.state.current_profile_image}  alt="" />
											</div>
											<div class="comt-text">
												<TextArea onChange={this.onChange} value={this.state.comment_text} name="comment_text" placeholder="Write A Comment...."/>
											</div>
											<div class="send-img">
												<img src={`${process.env.PUBLIC_URL}/assets/icons/right-arrow.png`} alt="" onClick={this.handleSubmit.bind(this,list.id)} loading={this.state.loading}/>
											</div>
										</div>
									</div>

							   </div>
							</div>
							</div>
						  </>
						  ))}
						</div>
					</div>
					</>
					  
					</Modal>
				   
				   
				</div>
				<div class="col-md-6">
					<div class="card widget-inline"> 
						<div class="card-body p-0">
							<div class="row no-gutters">

								<div class="col-sm-12 col-xl-6">
									<a href="#" class="text-secondary">
										<div class="card shadow-none m-0 border-left">
											<div class="card-body text-center">
												<i class="dripicons-network-3 text-muted" style={{'font-size': '24px'}}></i>
												<h3><span>{this.state.class_count}</span></h3>
												<p class="text-muted font-15 mb-0">Number Of Classes</p>
											</div>
										</div>
									</a>
								</div>

								<div class="col-sm-12 col-xl-6">
									<a href="#" class="text-secondary">
										<div class="card shadow-none m-0 border-left">
											<div class="card-body text-center">
												<i class="dripicons-network-3 text-muted" style={{'font-size': '24px'}}></i>
												<h3><span>{this.state.admission_count}</span></h3>
												<p class="text-muted font-15 mb-0">Number Of Admission Process</p>
											</div>
										</div>
									</a>
								</div>

								<div class="col-sm-12 col-xl-6">
									<a href="#" class="text-secondary">
										<div class="card shadow-none m-0 border-left">
											<div class="card-body text-center">
												<i class="dripicons-user-group text-muted" style={{'font-size': '24px'}}></i>
												<h3><span>{this.state.student_count}</span></h3>
												<p class="text-muted font-15 mb-0">Number Of Student</p>
											</div>
										</div>
									</a>
								</div>

								<div class="col-sm-2 col-xl-6">
									<a href="#" class="text-secondary">
										<div class="card shadow-none m-0 border-left">
											<div class="card-body text-center">
												<i class="dripicons-user-group text-muted" style={{'font-size': '24px'}}></i>
												<h3><span>{this.state.active_student_count}</span></h3>
												<p class="text-muted font-15 mb-0">Active Student</p>
											</div>
										</div>
									</a>
								</div>

								<div class="col-sm-12 col-xl-6">
									<a href="#" class="text-secondary">
										<div class="card shadow-none m-0 border-left">
											<div class="card-body text-center">
												<i class="dripicons-user-group text-muted" style={{'font-size': '24px'}} ></i>
												<h3><span>{this.state.inactive_student_count}</span></h3>
												<p class="text-muted font-15 mb-0">Inactive Student</p>
											</div>
										</div>
									</a>
								</div>
								
								{this.state.type == 'admin' && (<>
									<div class="col-sm-12 col-xl-6">
										<a href="#" class="text-secondary">
											<div class="card shadow-none m-0 border-left">
												<div class="card-body text-center">
													<i class="dripicons-user-group text-muted" style={{'font-size': '24px'}} ></i>
													<h3><span>{this.state.school_count}</span></h3>
													<p class="text-muted font-15 mb-0">Total No. Of Branches</p>
												</div>
											</div>
										</a>
									</div>
								</>)}
								

							</div> 
						</div>
					</div> 
				</div> 
			</div>
			<div class="row dashboard">
				<div class="col-12">
					<div class="card widget-inline"> 
						<div class="card-body p-0">
							<div class="row no-gutters">
								

							</div> 
						</div>
					</div> 
				</div> 
			</div>
			
			</>
		) 
	} 
}
export default Index;